import React from 'react'
import Dropdown from '@sl/ui-library/organisms/Dropdown'

const SelectValues = [
  {
    label: 'Pas de préférence',
    value: 'Pas de préférence',
  },
  {
    label: '09H - 12H',
    value: '09H - 12H',
  },
  {
    label: '12H - 14H',
    value: '12H - 14H',
  },
  {
    label: '14H - 16H',
    value: '14H - 16H',
  },
  {
    label: '16H - 19H',
    value: '16H - 19H',
  },
]

const MoveContactDateInput = ({ state, setState }) => {
  const { value } = state.contactSlot
  const handleContactDate = e => {
    setState(prev => ({
      ...prev,
      contactSlot: {
        ...prev.contactSlot,
        value: SelectValues.find(i => i.value === e),
        valid: true,
      },
    }))
  }

  const content = (
    <>
      <Dropdown
        values={SelectValues}
        maxDisplay={3}
        id="MooveFormLandingMoveContactDateInput"
        style={{ width: '100%' }}
        value={value.value}
        onChange={handleContactDate}
        defaultLabel="Mes disponibilités"
      />
    </>
  )

  return content
}

export default MoveContactDateInput
